import { totalParticipantes, getParticipantes } from './participantes.js';
import { actualizarPreciosLugar, getActividadSeleccionada } from './actividad_seleccionada.js';
import { getHoraSeleccionada } from './hora_seleccionada.js';

let currentStep = 1;

const stepTitles = {
  1: {
    title: "Paso 1: Lugar de la Actividad",
    subtitle: "Elige dónde realizarás la experiencia (el horario va incluido)"
  },
  2: {
    title: "Paso 2: Selecciona la Fecha",
    subtitle: "Elige el día de la actividad"
  },
  3: {
    title: "Paso 3: Participantes",
    subtitle: "Agrega todas las personas que participarán"
  },
  4: {
    title: "Paso 4: Datos de Contacto",
    subtitle: "Información del contacto principal"
  }
};

/** Nombres amigables para el resumen */
const nombresLugar = {
  "Alberca": "🏊 Piscina Climatizada",
  "La Herradura Almuñecar": "🌊 La Herradura",
  "Rincon de la Victoria": "🌊 Rincón de la Victoria"
};

const horariosLugar = {
  "Alberca": "19:00 – 21:00",
  "La Herradura Almuñecar": "14:00 – 16:00",
  "Rincon de la Victoria": "14:00 – 16:00"
};

export function showStep(step) {

  document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
  document.getElementById(`step-${step}`).classList.add('active');

  currentStep = step;

  // Cada vez que se muestre el paso de Hora y Lugar recalcula el precio
  if (step === 1) {
    actualizarPreciosLugar();
  }

  updateStepHeader();
  updateProgressUI();
  updateResumenSeleccion();
}

export function goToStep(step) {
  if (
    step === 1 ||
    step === 2 ||
    (step === 3 && getActividadSeleccionada()) ||
    (step === 4 && totalParticipantes() > 0)
  ) {
    showStep(step);
  }
}

export function nextStep() {

  // Paso 1: Lugar (el horario se asigna automáticamente)
  if (currentStep === 1) {
    if (!getActividadSeleccionada()) {
      return alert("⚠️ Selecciona un Lugar para realizar la actividad");
    }
  }

  // Paso 2: Fecha
  if (currentStep === 2 && !document.getElementById('fecha').value) {
    return alert("⚠️ Selecciona una fecha");
  }

  // Paso 3: Participantes
  if (currentStep === 3) {
    const n = totalParticipantes();
    const actividad = getActividadSeleccionada();
    if (actividad === "Alberca") {
      if (n !== 2) {
        return alert("⚠️ Para la Piscina Climatizada debes agregar exactamente 2 participantes");
      }
    } else if (n === 0) {
      return alert("⚠️ Debes agregar al menos un participante");
    }
  }

  if (currentStep < 4) {
    showStep(currentStep + 1);
  }
}

export function prevStep() {
  if (currentStep > 1) {
    showStep(currentStep - 1);
  }
}

export function updateStepHeader() {
  document.getElementById('step-title').textContent = stepTitles[currentStep].title;
  document.getElementById('step-subtitle').textContent = stepTitles[currentStep].subtitle;
}

export function updateProgressUI() {

  for (let i = 1; i <= 4; i++) {

    const circle = document.getElementById(`circle-${i}`);

    if (i < currentStep) {
      circle.classList.add('step-completed');
      circle.textContent = '✓';
    } else if (i === currentStep) {
      circle.classList.remove('step-completed');
      circle.textContent = i;
    } else {
      circle.classList.remove('step-completed');
      circle.textContent = i;
    }
  }

  document.getElementById('btn-prev').classList.toggle('hidden', currentStep === 1);
  document.getElementById('btn-next').classList.toggle('hidden', currentStep === 4);
  document.getElementById('btn-finish').classList.toggle('hidden', currentStep !== 4);
}

/**
 * Resumen compacto y progresivo de lo que el usuario ha seleccionado.
 * Se muestra debajo de la barra de pasos.
 */
export function updateResumenSeleccion() {
  const contenedor = document.getElementById('resumen-seleccion');
  if (!contenedor) return;

  const chipsWrap = contenedor.querySelector('div');
  if (!chipsWrap) return;

  const chips = [];

  // 1. Lugar + horario
  const actividad = getActividadSeleccionada();
  if (actividad) {
    const nombre = nombresLugar[actividad] || actividad;
    const horario = horariosLugar[actividad] || (getHoraSeleccionada() ? getHoraSeleccionada().slice(0, 5) : '');
    chips.push(chipHTML('📍', nombre + (horario ? ` · ${horario}` : '')));
  }

  // 2. Fecha
  const fechaInput = document.getElementById('fecha');
  const fechaRaw = fechaInput ? fechaInput.value : '';
  if (fechaRaw) {
    chips.push(chipHTML('📅', formatearFechaCorta(fechaRaw)));
  }

  // 3. Participantes
  const n = totalParticipantes();
  if (n > 0) {
    const lista = getParticipantes();
    const nombres = lista
      .slice(0, 2)
      .map(p => p.nombre)
      .join(', ');
    const extra = n > 2 ? ` +${n - 2}` : '';
    const texto = n === 1
      ? `1 participante${nombres ? `: ${nombres}` : ''}`
      : `${n} participantes${nombres ? `: ${nombres}${extra}` : ''}`;
    chips.push(chipHTML('👥', texto));
  }

  if (chips.length === 0) {
    contenedor.classList.add('hidden');
    chipsWrap.innerHTML = '';
    return;
  }

  chipsWrap.innerHTML = chips.join('<span class="text-white/50 select-none">·</span>');
  contenedor.classList.remove('hidden');
}

function chipHTML(icono, texto) {
  return `
    <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/80 text-slate-800 shadow-sm border border-white/60 text-xs sm:text-sm font-semibold max-w-[220px] truncate" title="${texto.replace(/"/g, '&quot;')}">
      <span>${icono}</span>
      <span class="truncate">${texto}</span>
    </span>
  `;
}

function formatearFechaCorta(yyyyMmDd) {
  try {
    const [y, m, d] = yyyyMmDd.split('-').map(Number);
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    return `${d} ${meses[m - 1]} ${y}`;
  } catch {
    return yyyyMmDd;
  }
}